import { useMemo } from 'react';
import { Layer, Source } from 'react-map-gl/maplibre';
import type { LineLayerSpecification } from 'maplibre-gl';
import { useGameStore } from '@/state/gameStore';
import type { VehicleStatus } from '@/state/types';

/** Color per leg type (matching VehicleMarkers ring). */
const COLORS: Record<VehicleStatus, string> = {
  1: '#3b82f6',
  2: '#3b82f6',
  3: '#3b82f6',
  4: '#3b82f6',
  5: '#3b82f6',
  6: '#3b82f6',
  7: '#f59e0b',
  8: '#f59e0b',
};

const LINE_LAYER: LineLayerSpecification = {
  id: 'vehicle-routes',
  type: 'line',
  source: 'vehicle-routes',
  paint: {
    'line-color': ['get', 'color'],
    'line-width': 3,
    'line-opacity': 0.65,
    'line-dasharray': [2, 1.5],
  },
};

/**
 * Renders dashed polylines for every active vehicle leg. Color encodes
 * the leg type (emergency vs transport). Only vehicles with a route in flight
 * contribute features.
 */
export function RouteLayers() {
  const vehicles = useGameStore((s) => s.vehicles);

  const geojson = useMemo(() => {
    const features = vehicles
      .filter(
        (v) =>
          v.routeCoords && v.routeCoords.length >= 2 && (v.status === 1 || v.status === 3 || v.status === 7),
      )
      .map((v) => ({
        type: 'Feature' as const,
        geometry: {
          type: 'LineString' as const,
          coordinates: v.routeCoords as [number, number][],
        },
        properties: { color: COLORS[v.status] ?? '#3b82f6', vehicleId: v.id },
      }));
    return { type: 'FeatureCollection' as const, features };
  }, [vehicles]);

  if (geojson.features.length === 0) return null;

  return (
    <Source id="vehicle-routes" type="geojson" data={geojson}>
      <Layer {...LINE_LAYER} />
    </Source>
  );
}
